import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import UserBookingMenu from './partials/UserBookingMenu';
import { itemService, globalService as gs } from '../../../../common/services';
import { alertSelectors } from '../../../../common/redux/selectors';
import moment from 'moment-timezone';
import Rating from '@material-ui/lab/Rating';
import Messenger from '../../Messanger';

class UserCompletedSessionsView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            item: null,
            parent: null,
            tutor: null,
            orders: null,
            extra: null,
            loading: false,
            ratingOpen: false,
            activeKey: null,
        };
    }

    componentDidMount() {
        const { match } = this.props;
        const item_id = match && match.params.id;
        this.loadBooking({order_id: item_id});
    }

    loadBooking = (params = null) => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.booking("GET", null, params).then(data => {
            if(data.code) {
                const item = data.model;
                const parent = item && item.actionBy;
                const tutor = item.userCatalogOrdersItems[0].user;
                const orders = item.userCatalogOrdersItems[0];
                const extra = JSON.parse(orders && orders.extra);
                this.setState({item, parent, tutor, orders, extra, loading: false, activeKey: item.message_key});
            }
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    render() {
        const { parent, tutor, orders, extra, activeKey } = this.state;
        return (<DashboardLayout activeClass="UserBooking">
            <section className="dashboard messages-page">
                <div id="msg-left">
                    <div className="row">
                        <UserBookingMenu activeClass="UserSessions" />
                        <div className="col-md-12">
                            <div className="post-box">
                                <div className="row">
                                    <div className="col-md-6 col-12 mb-4">
                                        <div className="media">
                                            <div className="image">
                                                <p className="text-primary ml-3 font-weight-bold mb-2">Tutor</p>
                                                <img className="mr-4 img-circle" src={tutor && tutor.avatar} alt="pic" width="70" height="70"/>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-4"><Link to={`/tutor/view/${tutor && tutor.id}`}>{tutor && tutor.name}</Link></h5>
                                                <div className="rating mb-2">
                                                    <span className="star">
                                                        {(tutor && tutor.rating_avg) && <Rating name="size-medium" value={parseInt(tutor.rating_avg)} readOnly />}
                                                    </span>
                                                    <span> ({tutor && tutor.rating_avg}) {tutor && tutor.count_rating} Ratings</span>
                                                </div>
                                                <div className="location">
                                                    <i className="fas fa-map-marker-alt"></i> {tutor && tutor.countryCode && tutor.countryCode.name}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-12 mb-4">
                                        <div className="media">
                                            <div className="image">
                                                <p className="text-primary ml-3 font-weight-bold mb-2">Parent</p>
                                                <img className="mr-4 img-circle" src={parent && parent.avatar && parent.avatar.thumb} alt="pic" width="70" height="70"/>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-5">{parent && parent.name}</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-9 col-12">
                                        <p className="text-primary font-weight-bold">Session Details</p>
                                        <div className="row">
                                            <div className="col-xl-5 col-12">
                                                <div className="inform">
                                                    <div className="d-flex">
                                                    <p className="text-primary font-weight-bold">Date : </p>
                                                        <div className="date">
                                                            {moment(orders && orders.start_time * 1000).format('MM/DD/YYYY')}<br/> {moment(orders && orders.start_time * 1000).format('LT')} - {moment(orders && orders.start_time * 1000).add(60, 'minutes').format('LT')}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex">
                                                        <p className="text-primary font-weight-bold">Completed Date : </p>
                                                        <div className="date"> 
                                                            {moment(orders && orders.updated_at * 1000).format('MM/DD/YYYY')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-6">
                                                <div className="inform">
                                                    <div className="d-flex">
                                                        <label>Cost :</label>
                                                        <div className="date">
                                                            ${orders && orders.price}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="inform">
                                                    <div className="d-flex">
                                                        <label>Duration :</label>
                                                        <div className="date">
                                                            60 min
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-12">
                                                <div className="sub">
                                                    <button className="btn btn-light">{orders && orders.catalog && orders.catalog.title}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-12">
                                        <p className="text-primary font-weight-bold">Payment Status</p>
                                        <div className="d-flex justify-content-between">
                                            <div className="date">Paid</div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 mt-4">
                                        <div className="d-flex flex-wrap justify-content-between">
                                            <div className="session">
                                                <p className="text-primary font-weight-bold">Session URL</p>
                                                <a href="#" rel="noopener noreferrer">{extra && extra.join_url}</a>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="msg-right">
                    {activeKey && <Messenger activeKey={activeKey} profile={tutor && tutor}/>}
                </div>
            </section>
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(UserCompletedSessionsView);